<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'

import AppBrand from '@/components/AppBrand.vue'
import AppNavigation from '@/components/AppNavigation.vue'
import AccountMenu from '@/components/AccountMenu.vue'
import PendingOperationNotice from '@/components/PendingOperationNotice.vue'
import ConnectionBadge from '@/components/ConnectionBadge.vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

</script>

<template>
  <div class="app-shell app-shell--refreshed">
    <header class="app-topbar">
      <RouterLink to="/market" class="app-topbar__brand"><AppBrand /></RouterLink>
      <AppNavigation />
      <div class="app-topbar__actions">
        <ConnectionBadge />
        <template v-if="auth.isAuthenticated">
          <div class="app-topbar__account"><AccountMenu /></div>
          <RouterLink to="/user-center" class="app-topbar__avatar" aria-label="前往用戶中心">{{ Array.from(auth.displayName)[0]?.toUpperCase() }}</RouterLink>
        </template>
        <template v-else>
          <RouterLink to="/login" class="button button--quiet">登入</RouterLink>
          <RouterLink to="/register" class="button button--primary app-topbar__register">註冊</RouterLink>
        </template>
      </div>
    </header>
    <main class="app-main"><PendingOperationNotice v-if="auth.isAuthenticated" /><RouterView /></main>
    <footer class="legal-footer">投資有風險，入市需謹慎</footer>
    <AppNavigation mobile />
  </div>
</template>

<style scoped>
.app-shell--refreshed { background: radial-gradient(ellipse at 95% 0, rgba(38,118,147,.1), transparent 42%); }
.app-topbar { position: sticky; z-index: 30; top: 0; display: grid; grid-template-columns: minmax(180px, .7fr) auto minmax(180px, 1fr); min-height: 74px; align-items: center; gap: 24px; padding: 0 32px; border-bottom: 1px solid var(--line); background: rgba(7,16,29,.95); backdrop-filter: blur(20px); }
.app-topbar__brand { display: inline-flex; width: fit-content; min-height: 44px; align-items: center; }
.app-topbar__actions { display: flex; min-width: 0; align-items: center; justify-content: flex-end; gap: 12px; }
.app-topbar__avatar { display: none; }
@media (max-width: 1180px) { .app-topbar { gap: 14px; padding-inline: 22px; grid-template-columns: auto 1fr auto; } .app-topbar__actions .connection-badge { display: none; } }
@media (max-width: 900px) {
  .app-topbar { min-height: 65px; grid-template-columns: minmax(0, 1fr) auto; gap: 12px; padding: 8px 18px; backdrop-filter: none; background: #081420; }
  .app-topbar :deep(.brand__mark) { width: 35px; height: 35px; border-radius: 11px; }
  .app-topbar :deep(.brand__copy strong) { font-size: 1rem; }
  .app-topbar :deep(.brand__copy small) { font-size: .55rem; }
  .app-topbar__actions { gap: 8px; }
  .app-topbar__account { display: none; }
  .app-topbar__avatar { display: grid; width: 44px; height: 44px; place-items: center; border: 1px solid rgba(112,211,200,.25); border-radius: 14px; background: linear-gradient(145deg, #234e54, #122c3a); color: #9af2dd; font-size: 1rem; font-weight: 750; box-shadow: inset 0 1px 0 rgba(255,255,255,.06); }
  .app-topbar__avatar:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 3px; }
  .app-topbar__actions .button { min-height: 44px; padding-inline: 14px; font-size: .75rem; }
  .app-main { width: min(calc(100% - 32px), 760px); padding-top: 20px; padding-bottom: 24px; }
  .legal-footer { padding: 12px 16px calc(94px + env(safe-area-inset-bottom)); font-size: .64rem; }
}
@media (max-width: 350px) { .app-topbar { padding-inline: 14px; } .app-topbar__register { display: none; } .app-main { width: calc(100% - 24px); } }
</style>
